import React from "react";

import "./diagonal-section.css"
import TechStack from "../techStack/techStack";

type DiagonalVariant =
    | "default"
    | "flip-x"
    | "top"
    | "top-flip-x"
    | "bottom"
    | "bottom-flip-x";

interface DiagonalSectionProps {
    title?: string;
    subtitle?: string;
    variant?: DiagonalVariant;
    className?: string;
    children?: React.ReactNode;
}

const DiagonalSection: React.FC<DiagonalSectionProps> = ({
                                                             title,
                                                             subtitle,
                                                             variant = "default",
                                                             className = "",
                                                             children,
                                                         }) => {
    const variantClassMap: Record<DiagonalVariant, string> = {
        default: "diagonal-section",
        "flip-x": "diagonal-section diagonal-section--flip-x",
        top: "diagonal-section-top",
        "top-flip-x": "diagonal-section-top diagonal-section-top--flip-x",
        bottom: "diagonal-section-bottom",
        "bottom-flip-x":
            "diagonal-section-bottom diagonal-section-bottom--flip-x",
    };

    return (
        <section className={`${variantClassMap[variant]} ${className}`}>
            <div className="cd-container cd-max-width-sm cd-padding-y-3xl">
                {/*<div className="cd-text-center">*/}
                    {/*<h1 className="cd-margin-bottom-sm">{title}</h1>*/}
                    {/*{subtitle && <p>{subtitle}</p>}*/}
                    <TechStack/>
                {/*</div>*/}
            </div>
        </section>
    );
};

export default DiagonalSection;
